export const ACTIONPLANS_MODULE_NAME = ['actionplans'];

export const ACTIONPLANS_ACTIONS_MODULE_NAME = [
  ...ACTIONPLANS_MODULE_NAME,
  'actions',
];
export const ACTIONPLANS_ACTIONS_USER_EXCHANGES_MODULE_NAME = [
  ...ACTIONPLANS_ACTIONS_MODULE_NAME,
  'user_exchanges',
];

export const ACTIONPLANS_ACTIONS_USER_EXCHANGES_TYPES_MODULE_NAME = [
  ...ACTIONPLANS_ACTIONS_USER_EXCHANGES_MODULE_NAME,
  'types',
];
